import {Image} from "@/images/Image.ts";
import {baseUrl, http} from "@/api/HttpClient.ts";
import {v4 as UUID} from "uuid";
import {getImageDimensions} from "@/images/getImageDimensions.ts";

export function srcUrl(image: Image) {
    return `${baseUrl}/images/download/${image.id}`
}

export async function uploadImage(file: File): Promise<Image> {
    const dimensions = await getImageDimensions(file)
    const image = {
        id: UUID(),
        fileName: file.name,
        ...dimensions,
    }
    const formData = new FormData();
    formData.append("file", file as Blob);
    formData.append("image", new Blob([JSON.stringify(image)], {type: "application/json"}));
    const res = await http.post(`/images/upload`, formData);
    return res.data;
}

export async function uploadTemporaryImage(file: File, signal?: AbortSignal): Promise<Image> {
    const formData = new FormData();
    formData.append("file", file);
    const res = await http.post<Image>(`/images/temporary`, formData, {signal});
    return res.data;
}

export async function discardTemporaryImage(image: Image): Promise<void> {
    await http.delete(`/images/temporary/${image.id}`);
}

export async function deleteImage(image: Image): Promise<void> {
    await http.delete(`/images/delete/${image.id}`)
}
